import { getLevelArrayMetric as e } from "../index4.js";
import { getLevelUnitToLiftCoreRatio as r } from "../level-metrics/index34.js";
const L = (t) => e(t, r);
export {
  L as getLevelArrayUnitToLiftCoreRatio
};
//# sourceMappingURL=index18.js.map
